<template lang="pug">
    b-button.mb-0(:type="type", :class="classes", @click="$emit('clicked')", :disabled="flag")
      b-spinner.mr-2(v-if="flag", type="grow", small)
      span {{ label }}
</template>

<script>

export default {
  name: 'loader',
  data() {
    return {
    };
  },
  props: ['label', 'flag', 'type', 'classes'],
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/ButtonLoad.vue